import { List, Record } from "immutable";

export interface IEstimateCommissionOutputObjectData {
  title: string;
  value: string;
  formatted: string;
}

export interface IEstimateCommissionOutputObjectRecord {
  title: string;
  value: string;
  formatted: string;
}

const defaultOutputObjectProps: IEstimateCommissionOutputObjectRecord = {
  title: "",
  value: "",
  formatted: "",
};

export class EstimateCommissionOutputObjectRecord
  extends Record(defaultOutputObjectProps)
  implements IEstimateCommissionOutputObjectRecord {}

export const estimateCommissionOutputObjectFromJSON = (
  json: Partial<IEstimateCommissionOutputObjectData>,
): EstimateCommissionOutputObjectRecord => new EstimateCommissionOutputObjectRecord(json);

export interface IEstimateCommissionOutputData {
  verbose_output: string[];
  verbose_output_objects: IEstimateCommissionOutputObjectData[];
}

export interface IEstimateCommissionOutputRecord {
  verbose_output: List<string>;
  verbose_output_objects: List<EstimateCommissionOutputObjectRecord>;
}

const defaultOutputProps: IEstimateCommissionOutputRecord = {
  verbose_output: List<string>(),
  verbose_output_objects: List<EstimateCommissionOutputObjectRecord>(),
};

export class EstimateCommissionOutputRecord
  extends Record(defaultOutputProps)
  implements IEstimateCommissionOutputRecord {}

export const estimateCommissionOutputFromJSON = (
  json: Partial<IEstimateCommissionOutputData>,
): EstimateCommissionOutputRecord => {
  const record: IEstimateCommissionOutputRecord = { ...defaultOutputProps };

  if (json.verbose_output) {
    record.verbose_output = List(json.verbose_output);
  }
  if (json.verbose_output_objects) {
    record.verbose_output_objects = List(json.verbose_output_objects.map(estimateCommissionOutputObjectFromJSON));
  }

  return new EstimateCommissionOutputRecord(record);
};

export interface IEstimateCommissionData {
  apl_current: boolean;
  generated_by_user_name: string;
  output: IEstimateCommissionOutputData;
  loading?: boolean;
}

export interface IEstimateCommissionRecord {
  apl_current: boolean;
  generated_by_user_name: string;
  output: EstimateCommissionOutputRecord;
  loading: boolean;
}

const defaultEstimateCommissionProps: IEstimateCommissionRecord = {
  apl_current: false,
  generated_by_user_name: "",
  output: estimateCommissionOutputFromJSON({}),
  loading: false,
};

export class EstimateCommissionRecord
  extends Record(defaultEstimateCommissionProps)
  implements IEstimateCommissionRecord {}

export const estimateCommissionFromJSON = (json: Partial<IEstimateCommissionData>): EstimateCommissionRecord => {
  const record: IEstimateCommissionRecord = { ...(json as any) };

  record.output = estimateCommissionOutputFromJSON(json.output ?? {});

  return new EstimateCommissionRecord(record);
};
